export class Sdk {
    constructor(defaultFlags) {
        this.subscriptions = new Map();
        this.flags = defaultFlags;
    }
    onChange(property, handler) {
        if (!this.subscriptions.has(property)) {
            this.subscriptions.set(property, []);
        }
        this.subscriptions.get(property)?.push(handler);
        handler(this.flags[property]);
        return () => {
            const idx = this.subscriptions.get(property)?.indexOf(handler) ?? -1;
            if (idx >= 0) {
                this.subscriptions.get(property)?.splice(idx, 1);
            }
        };
    }
    updateFlag(property, value) {
        this.flags[property] = value;
        this.subscriptions.get(property)?.forEach(callback => callback(value));
    }
}
//# sourceMappingURL=sdk_base.js.map